import React, { useContext, useState, useEffect } from 'react';
import { format, addDays } from 'date-fns';
import { Context } from '../../services/contexts/StateContext';
import api from '../../services/api';
import * as S from './styles';
import editar from '../../midia/editar.svg';
import delet from '../../midia/delete.svg';
import icon_File from '../../midia/icon_pdf.svg';
// -----------------------------------------------
import { AlertComp } from '../alerte/index';
import { FunctModal } from '../Functions';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
import { descricaoParaTexto } from '../../services/descricaoEventoUtil';


//###############################################
export const ListaEventosPlaca = (props) => {
    const { state, dispatch } = useContext(Context);
    const { evento, terceiro, guincho } = state.evento;
    const { veiculo } = state.veiculo;
    const { cliente, logado } = state.cliente;
    const { parametroInit, playmodal, listaPesquisa } = state.parametros;

    const [alertDelete, setAletDelete] = useState(false);
    const { FecharModal } = FunctModal();
    const dataAtual = new Date();
    const { PesqVistoriaPlaca } = ApiEvento();

    const [pegarId, setpegarId] = useState("")

    //--------------------------------------------------
    function FecharAlerte() {
        setAletDelete(false)
    };

    //----------------------------------------------
    function podeExcluir(t) {
        const idCadastro = t?.userCadastro?._id ?? t?.userCadastro;
        return logado.nivel === "master" || (!!idCadastro && String(idCadastro) === String(logado.idLogado));
    }

    function lixeira(t) {
        if (!podeExcluir(t)) return;
        setpegarId(t._id);
        // dispatch({
        //     type: 'set_ListaPesquisa',
        //     payload: { ...listaPesquisa, listaEvento: [t] }
        // });

        setAletDelete(true);
        props.setNewStatus('E');
        props.setRefDelet("evento");
    };

    //-----------------------------------------------
    async function ExcluirEste() {
        await api.put(`evento/atualizarSimples/${pegarId}`, {
            status: 'E',
            logs: {
                idUsuario: logado.id_Cliente,
                acao: 'excluir evento',
                plataforma: "interno",
                localizacao: {
                    latitude: veiculo.latitude ? veiculo.latitude : null,
                    longitude: veiculo.longitude ? veiculo.longitude : null,
                }
            }
        })
        .then(res => {
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    listaEvento: listaPesquisa.listaEvento.filter(ev => ev._id !== pegarId),
                }
            });
            setAletDelete(false);
        })
    };

    // -----------------------------------------
    useEffect(() => {
        if (listaPesquisa.listaEvento.length > 1) {
            dispatch({
                type: 'SET_PLAYMODAL',
                payload: {
                    ...playmodal,
                    playModalDetalhesEven: false,
                }
            });
        }
    }, [listaPesquisa.listaEvento])

    //---------------------------------------------------
    function detalheEvento(t) {
        
        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                listaEvento: [t],
            }
        });

        dispatch({
            type: 'set_cliente',
            payload: {
                ...cliente,
                id_Cliente: t?.id_Veiculo?.id_Cliente?._id,
                nome: t?.id_Veiculo?.id_Cliente?.nome,
            }
        });

        dispatch({
            type: 'set_Evento',
            payload: {
                ...evento,
                "id_Evento": t._id,
                "nomeCliente": t?.id_Veiculo?.id_Cliente?.nome,
                id_Fornecedor: t?.id_Fornecedor?._id,
                fornecedor: t?.id_Fornecedor?.nome,
                cnpjForne: t?.id_Fornecedor?.cnpj,
                chavePix: t?.id_Fornecedor?.chavePix,
                "tipo": t.tipo,
                "tipoEvento": t.tipoEvento,
                "codEvento": t.codEvento,
                "dataEvento": t.dataEvento ? String(t.dataEvento).slice(0, 10) : '',
                "ocorrenciaBO": t.ocorrenciaBO,
                "descricao": descricaoParaTexto(t.descricao),
                "descricaoOriginal": t.descricao,
                "status": t.status,
                "placa": t.placa,
                "narracao": t.narracao,
                orcamento: t.orcamento ? t.orcamento : 0,
                userCadastro: t?.userCadastro?.nome,
                numeroParcelas: t.financiamento?.n_Parcelas || "",
                valorParcela: t.financiamento?.valorParcela || "",
                diaVencimento: t.financiamento?.vencimento || "",
                primeiraParcela: t.financiamento?.primeiraParcela ? format(new Date(t.financiamento.primeiraParcela), 'yyyy-MM-dd') : "",

                inicioCReserva: t.inicioCReserva ? format(new Date(t.inicioCReserva), 'yyyy-MM-dd') : '',
                fimCReserva: t.fimCReserva ? format(new Date(t.fimCReserva), 'yyyy-MM-dd') : '',

                dataPart: t.dataPart ? format(new Date(t.dataPart), 'yyyy-MM-dd') : '',
                valorPart: t.valorPart,
                detalhePart: t.detalhePart,

                dataPag: t.dataPag ? format(new Date(t.dataPag), 'yyyy-MM-dd') : "",
                valorPag: t.valorPag,
                formaPag: t.formaPag,

                arquivos: t?.arquivos.reverse()
            }
        });

        dispatch({
            type: 'set_Guincho',
            payload: { 
                ...guincho, 
                origem: t.guincho?.origem || "",
                destino: t.guincho?.destino || "",
                km: t.guincho?.km || "",
            }
        });

        dispatch({
            type: 'set_veiculo',
            payload: {
                ...veiculo,
                id_Veiculo: t?.id_Veiculo?._id,
                placa: t?.id_Veiculo?.placa,
                modelo: t?.id_Veiculo?.modelo,
                nomeCliente: t?.id_Veiculo?.id_Cliente?.nome

            }
        });

        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                detalhesLista: true,
                disabledEven: true,
            }
        });

        dispatch({
            type: 'SET_PLAYMODAL',
            payload: {
                ...playmodal,
                playModalOrcamento: false,
                playModalEven: false,
                playModalDetalhesEven: playmodal.playModalDetalhesEven ? false : true,
            }
        });

        if (t.terceiro) {
            dispatch({
                type: 'set_Terceiro',
                payload: {
                    ...terceiro,
                    "tipo": t.terceiro.tipo,
                    "placa": t.terceiro.placa,
                    "chassi": t.terceiro.chassi,
                    "anoMod": t.terceiro.anoMod,
                    "montadora": t.terceiro.montadora,
                    "modelo": t.terceiro.modelo,
                    "cor": t.terceiro.cor,
                    "valorFipe": t.terceiro.valorFipe,
                    "anexoCNH": t.terceiro.anexoCNH,
                }
            });
        };

        if (playmodal.playModalEven) {
            FecharModal();
        };
    };

    // ---------------------------------------

    function FuncNomeEvento({tipo}) {
        
        if (tipo === "Guincho_Mecanica"){
            return "Guincho Mecanica"
        };

        if (tipo === "Guincho_Eletrica"){
            return "Guincho Eletrica"
        };

        if (tipo === "Guincho_Colisao"){
            return "Guincho Colisão"
        };

        if (tipo === "Recarga"){
            return "Recarga Bateria"
        };

        if (tipo === "Reserva"){
            return "Carro Reserva"
        };

        if (tipo === "Retorno"){
            return "Retorno Domicilio"
        };

        if (tipo === "Vidro_part"){
            return "Para-brisa/vidro"
        };

        if (tipo === "Retrovisor_part"){             
            return "Retrovisor"
        };
        if (tipo === "Reparos_part"){
            return "Pequenos Reparo"
        };

        if (tipo === "Colisao_part"){
            return "Colisão"
        }else {
            return tipo || "Não Definido"
        };
    };


    //###################################################################
    return (
        <S.bodyresult>
            {props.listaBusca.length > 0 && 
            <>
                {alertDelete &&
                    <AlertComp
                        alertDescrit={'Deseja mesmo Excluir?'}
                        seSim={ExcluirEste}
                        seNao={FecharAlerte}
                    />
                }

                <S.ListaVistoria titulo={true}>                    
                    <span style={{ flex:"0.5", minWidth:"65px", marginLeft: "3px" }}> Data Evento </span>
                    <span style={{flex:"0.7", 'textTransform': "uppercase" }}>Placa</span>
                    <span>Tipo Evento</span>
                    <span style={{flex:"0.7", justifyContent: "start"}}> Orçamento </span>

                    <span style={{minWidth:"65px", flex:"0", justifyContent: "end"}}>
                        <img
                            className='icone'
                        />
                        <img
                            className='icone'
                        />
                    </span>
                </S.ListaVistoria>

                {props.listaBusca.map((t, k) => 
                <S.ListaVistoria key={k}>                    
                    <span style={{ flex:"0.5", minWidth:"65px", marginLeft: "3px" }}>
                        {t.dataEvento? format(new Date(t.dataEvento), 'dd/MM/yyyy') : '--/--/----'}
                    </span>
                    <span style={{flex:"0.7", 'textTransform': "uppercase" }}>{t.placa}</span>

                    <span>{ <FuncNomeEvento tipo={t.tipoEvento}/> }</span>
                    
                    <span style={{flex:"0.7", justifyContent: "start", color: t.orcamento ? "blue" : "black" }}>
                        {parseFloat(t.orcamento ? t.orcamento : 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                    </span>

                    <span style={{minWidth:"65px", flex:"0", justifyContent: "end"}}>
                        {t.arquivos.length > 0 &&
                            <img
                                className='icone'
                                src={icon_File}
                                onClick={() => { }}
                                alt="icone"
                            />
                        }

                        <img
                            className='icone'
                            style={{width:"18px"}}
                            src={editar}
                            onClick={() => detalheEvento(t)}
                            alt="icone"
                        />

                        {podeExcluir(t) &&
                        <img
                            className='icone'
                            style={{width:"18px"}}
                            src={delet}
                            onClick={() => lixeira(t)}
                            alt="icone"
                        />}
                    </span>
                </S.ListaVistoria>
                )}
            </>}
        </S.bodyresult>


    )
}